import React from "react";


const renderModel23Tooltip = (feature) => {
    const {properties} = feature;

    return <div>
        <div>{properties?.station?.code} - {properties?.station?.name}</div>
        {properties?.elevation !== null && <div>{properties?.elevation} mt.</div>}
    </div>
}


export default renderModel23Tooltip;